module.exports = __webpack_public_path__ + "static/media/empty_data_working_time.843e8947.png";